import { render, staticRenderFns } from "./ReviewGradeSheet.vue?vue&type=template&id=a1fdbdce&scoped=true"
import script from "./ReviewGradeSheet.vue?vue&type=script&lang=js"
export * from "./ReviewGradeSheet.vue?vue&type=script&lang=js"
import style0 from "./ReviewGradeSheet.vue?vue&type=style&index=0&id=a1fdbdce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fdbdce",
  null
  
)

export default component.exports